module.exports = __webpack_public_path__ + "media/images/errors/404-2a085d5777d7c4124f06ff88400eee51.png";